import {useActions, useGetters, useMutators, useState} from './_default';
import axios from "axios";
export default {
    namespaced: true,
    state: {
        check: false,
        user: null,
        prev: null,
        logo: null,
        sharingHash: null,
        stats: {},
        version: 1,
        socketChannels: {},
    },
    getters: {
        check: state => state.check,
        user: state => state.user,
        userId: state => state.user?.id,
        prev: state => state.prev,
        stats: state => state.stats,
        version: state => state.version,
        socketChannels: state => state.socketChannels,
        sharingHash: state => state.sharingHash,
    },
    mutations: {
        prepare() {},
        check(state, status) {
            state.check = status;
        },
        user(state, user) {
            state.user = user;
        },
        updateUser(state, data) {
            state.user = Object.assign(state.user, data);
        },
        prev(state, user) {
            state.prev = user;
        },
        setLocale(state, lang) {
            state.user.lang = lang;
        },
        stats(state, stats) {
            state.stats = stats;
        },
        version(state, version) {
            state.version = version;
        },
        socketChannels(state, channels) {
            state.socketChannels = channels;
        },
        sharingHash(state, hash) {
            state.sharingHash = hash;
        }
    },
    actions: {
        loadUserStats({ state }) {
            axios.get('/payload/stats').then((response) => {
                state.stats = response.data.data;
            });
        }
    },
}
